/**
 *  @class
 *  @function RemoveAll
 */
const removeAllDebounce = window.debounce || function (fn, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn.apply(this, args), wait);
  };
};

if (!customElements.get('remove-all')) {
  class RemoveAll extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.drawer = this.closest('cart-drawer');
      this.debouncedOnSubmit = removeAllDebounce(() => {
        this.onSubmitHandler();
      }, 200);
      this.addEventListener('click', this.debouncedOnSubmit.bind(this));
    }
    onSubmitHandler() {
      this.classList.add('loading');
      const note = document.getElementById('mini-cart__notes')?.value || '';

      fetch(`${theme.routes.cart_clear_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': `application/json`
        },
        body: JSON.stringify({
          'note': note
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Cart clear failed with status ${response.status}`);
          }
          return response.json().catch(() => null);
        })
        .then(() => {
          this.drawer?.refresh?.();
        })
        .catch((error) => {
          console.error('Error clearing cart:', error);
        })
        .finally(() => {
          this.classList.remove('loading');
        });
    }
  }
  customElements.define('remove-all', RemoveAll);
}
